import Vue from "vue";
import VueRouter from "vue-router";
import NsPay from "../views/NsPay";
import Landing from "../views/Landing";
import CreditCardBraintree from "../views/CreditCardBraintree";
import CreditCardPayeezy from "../views/CreditCardPayeezy";
import CreditCardShift4 from "../views/CreditCardShift4";
import Tip from "../views/Tip";
import PaymentSummary from "../views/PaymentSummary";
import CVVInfo from "../components/CVVInfo";
import Error from "../views/Error";
import Links from "../views/Links";
import { sessionDataExists } from "../mixins/session-storage";
import { keynames } from "../constants/keynames";

Vue.use(VueRouter);

const routes = [
    {
        path: "/landing",
        name: "Landing",
        component: Landing
    },
    {
        path: "/",
        name: "NsPay",
        component: NsPay
    },
    {
        path: "/links",
        name: "Links",
        component: Links
    },
    {
        path: "/tip",
        name: "Tip",
        component: Tip
    },
    {
        path: "/paymentsummary",
        name: "PaymentSummary",
        component: PaymentSummary
    },
    {
        path: "/creditcard/0",
        name: "CreditCardBraintree",
        component: CreditCardBraintree
    },
    {
        path: "/creditcard/1",
        name: "CreditCardPayeezy",
        component: CreditCardPayeezy
    },
    {
        path: "/creditcard/2",
        name: "CreditCardShift4",
        component: CreditCardShift4
    },
    {
        path: "/cvvinfo",
        name: "CVVInfo",
        component: CVVInfo
    },
    {
        path: "/error/:errorCode?",
        name: "Error",
        component: Error,
        props: true
    },
    {
        path: "*",
        name: "NotFound",
        redirect: "/error/404"
    }
];

const router = new VueRouter({
    mode: "history",
    base: window.location.pathName,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.name === "Tip" && from.name !== "NsPay") {
        next({ name: "Landing" });
    }
    else if (to.name === ("CreditCardPayeezy")) {
        if (from.name === "NsPay" || sessionDataExists(keynames.checkUrl)) {
            next();
        }
        else {
            next({ name: "Landing" });
        }
    }
    else if (to.name.startsWith("CreditCard") && from.name !== "NsPay") {
        next({ name: "Landing" });
    }
    else if (to.name === "PaymentSummary" &&
        !(from.name === "NsPay" || from.name.startsWith("CreditCard"))) {
        next({ name: "Landing" });
    }
    else if (to.name === "Error" && from.name === null &&
        to.path.toLowerCase() !== "/error/1001") {
        // Redirecting user to a generic error page when user tries to access the 
        // error page directly to probably view different error messages by
        // changing the error code in the url.
        next({ name: "Error", params: { errorCode: "1001" } });
    }
    else {
        next();
    }
});

export default router;
